/* tslint:disable */
/* eslint-disable */
/**
 * OasisExplorer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlocksRow
 */
export interface BlocksRow {
    /**
     * 
     * @type {number}
     * @memberof BlocksRow
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof BlocksRow
     */
    hash: string;
    /**
     * 
     * @type {number}
     * @memberof BlocksRow
     */
    level: number;
    /**
     * 
     * @type {number}
     * @memberof BlocksRow
     */
    number_of_txs?: number;
    /**
     * 
     * @type {number}
     * @memberof BlocksRow
     */
    epoch?: number;
    /**
     * 
     * @type {string}
     * @memberof BlocksRow
     */
    proposer?: string;
    /**
     * 
     * @type {number}
     * @memberof BlocksRow
     */
    number_of_signatures?: number;
    /**
     * 
     * @type {number}
     * @memberof BlocksRow
     */
    fees?: number;
    /**
     * 
     * @type {number}
     * @memberof BlocksRow
     */
    gas_used?: number;
}

export function BlocksRowFromJSON(json: any): BlocksRow {
    return BlocksRowFromJSONTyped(json, false);
}

export function BlocksRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlocksRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'],
        'hash': json['hash'],
        'level': json['level'],
        'number_of_txs': !exists(json, 'number_of_txs') ? undefined : json['number_of_txs'],
        'epoch': !exists(json, 'epoch') ? undefined : json['epoch'],
        'proposer': !exists(json, 'proposer') ? undefined : json['proposer'],
        'number_of_signatures': !exists(json, 'number_of_signatures') ? undefined : json['number_of_signatures'],
        'fees': !exists(json, 'fees') ? undefined : json['fees'],
        'gas_used': !exists(json, 'gas_used') ? undefined : json['gas_used'],
    };
}

export function BlocksRowToJSON(value?: BlocksRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'hash': value.hash,
        'level': value.level,
        'number_of_txs': value.number_of_txs,
        'epoch': value.epoch,
        'proposer': value.proposer,
        'number_of_signatures': value.number_of_signatures,
        'fees': value.fees,
        'gas_used': value.gas_used,
    };
}


